module.exports = __webpack_public_path__ + "static/media/google.bb01a8a9.svg";